var exports = {
  "wZ": "xf0b3b88a--484417--success-block",
  "pD": "xf0b3b88a--484417--mobile-content",
  "W4": "xf0b3b88a--484417--text-wrapper",
};

module.exports = exports;
